<template>
	<v-container>
		<v-row justify="center">
			<v-col cols="12" sm="10">
				<v-data-table
					:headers="headers"
					:items="customers"
					item.key='items.user_uid'
					no-data-text="Cargando Clientes ..."
					 v-if='loaded'
				>
				<!-- slot Top table -->
					<template v-slot:top>
						<v-toolbar flat color="white">
							<v-toolbar-title>Gestión de Clientes</v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
							<v-spacer />
							<customer-dialog />
						</v-toolbar>
					</template>
				<!-- Status -->
				<template v-slot:item.active="{ item }">
					<v-switch
							color="success"
							v-model="item.active"
							@change="toogleStatus(item)"
					></v-switch>

				</template>
					<!-- columna accion -->
					<template v-slot:item.action="{ item }">
						<v-icon   @click="edit(item)">
							mdi-file-edit
						</v-icon>
						<v-icon
							@click="remove(item, items.map(function(x) {return x.user_uid; }).indexOf(item.id))"
							color="red"
						>
							mdi-delete
						</v-icon>
					</template>
				</v-data-table>

				<v-container v-else fill-height>
						<v-layout flex align-center justify-center>
						<v-progress-circular indeterminate :size="100" :widht="45" color="secondary" />
					</v-layout>
				</v-container>

				
			</v-col>
		</v-row>
		<v-snackbar
			:timeout="alert.timeout"
			:color="alert.color"
			v-model="alert.show"
		>
			{{ alert.message }}
		</v-snackbar>

	</v-container>


</template>

<script>
	import { mapState, mapActions, mapGetters} from 'vuex';
	import { db } from '@/main';
	export default {
		name: 'CustomersAdmin',
		components: {
			CustomerDialog: () => import('@/components/admin/CustomerDialog.vue'),
		},
		created(){
			this.getCustomers()
		},
		data: () => ({
			headers: [
				{text: 'Nombre', value: 'name', align: 'left'},
				{text: 'email', value: 'email', align: 'left'},
				{text: 'Estado', value: 'active', align: 'left'},
				{text: '', value: 'action', sortable: false,align: 'end', },
			],
			items: []
		}),
		methods: {
			...mapActions('customerModule', ['getCustomers','toggleCustomerDialog']),
			edit(customer){
				this.toggleCustomerDialog({editMode: true, customer})
			},
			remove(item,i)
			{
				console.log(item)
				console.log(i)
			},
			toogleStatus(item){
				db.collection('customers').doc(item.id).update({ active: item.active });
			},
		},
		computed: {
			...mapState('customerModule',['customers','customer']),
			...mapState(['loaded','alert']),
			...mapGetters('customerModule',['customerForEdit', 'customerDialogEditMode','customersDialog']),

		},
	}
</script>

<style lang="scss" scoped>

</style>